/**
 * Mobile panel sheet - contains the mode selector and panel content
 */

import { Sheet, SheetContent } from '@frameit/ui';
import { useProjectStore } from '../../stores/projectStore';
import { MobileModeSelector } from './MobileModeSelector';
import { FrameSelector } from './FrameSelector';
import { MatSelector } from './MatSelector';
import { ImageTransformPanel } from './ImageTransformPanel';
import { PaperSelector } from './PaperSelector';
import { EffectsPanel } from './EffectsPanel';
import { SceneSelector } from './SceneSelector';
import { GalleryWallEditor } from './GalleryWallEditor';
import { ExportPanel } from '../export/ExportPanel';

export function MobilePanelSheet() {
  const editorMode = useProjectStore((s) => s.editorMode);
  const mobilePanelOpen = useProjectStore((s) => s.mobilePanelOpen);
  const setMobilePanelOpen = useProjectStore((s) => s.setMobilePanelOpen);

  return (
    <Sheet open={mobilePanelOpen} onOpenChange={setMobilePanelOpen} defaultSnapPoint={60}>
      <SheetContent showOverlay={true} draggable={true}>
        {/* Mode selector tabs */}
        <MobileModeSelector />

        {/* Panel content */}
        <div className="flex-1 overflow-auto pb-6">
          {editorMode === 'frame' && <FrameSelector />}
          {editorMode === 'mat' && <MatSelector />}
          {editorMode === 'image' && <ImageTransformPanel />}
          {editorMode === 'paper' && <PaperSelector />}
          {editorMode === 'effects' && <EffectsPanel />}
          {editorMode === 'scene' && <SceneSelector />}
          {editorMode === 'gallery' && <GalleryWallEditor />}
          {editorMode === 'export' && <ExportPanel />}
        </div>
      </SheetContent>
    </Sheet>
  );
}
